



















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Page } from "yellowfin-ui-lib";
import { Anagrafica } from "@/data/models/anagrafica.model";

@Component({})
export default class AnagraficaTable extends Vue {
  @Prop() data!: Anagrafica[];
  @Prop() page!: Page;
  @Prop() loading!: boolean;
  @Prop() albobase!: string;

  base = "";
  firstload = true;

  @Watch("data")
  onDataChange() {
    this.firstload = false;
  }

  onPageChange(page: number) {
    this.$emit("page", page);
  }

  mounted() {
    const uri = window.location.search.substring(1);
    const params = new URLSearchParams(uri);
    const patha = location.pathname;
    let path =
      this.albobase != undefined && this.albobase != "" ? this.albobase : patha;

    if (path.startsWith("/")) {
      path = path.substring(1);
    }

    if (params && (!this.albobase || this.albobase == "")) {
      this.base = "/" + path + "?" + uri + "&profileid=";
    } else {
      this.base = "/" + path + "?profileid=";
    }
  }
}
